
export enum Role {
  ADMIN = 'ADMIN',
  MANAGER = 'MANAGER',
  DEPARTMENT_MANAGER = 'DEPARTMENT_MANAGER',
  NFC_OPERATOR = 'NFC_OPERATOR',
  USER = 'USER',
}

export enum EmployeeStatus {
  PERMANENT = 'KADROLU',
  SEASONAL = 'MEVSİMLİK',
  TEMPORARY = 'GEÇİCİ',
  INTERN = 'STAJYER',
}

export interface Department {
  id: string;
  name: string;
  managerId?: string;
  description?: string;
}

export interface Location {
  id: string;
  name: string;
  address: string;
  type: 'OFFICE' | 'WAREHOUSE' | 'REMOTE';
}

export interface Unit {
  id: string;
  departmentId: string;
  name: string;
}

export interface Shift {
  id: string;
  name: string;
  startTime: string; // HH:mm
  endTime: string; // HH:mm
  toleranceEntry: number; // minutes
  toleranceExit: number; // minutes
  breakDuration: number; // minutes
}

export interface Employee {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  departmentId: string;
  unitId: string;
  role: Role;
  status: EmployeeStatus;
  position: string;
  hireDate: string;
  salary: number;
  grossSalary?: number; // Aylik brut maas
  netSalary?: number; // Aylik net maas
  avatarUrl?: string;
  shiftId: string;
  clothingSize?: string;
  documents: string[]; // List of doc names
  leaveBalance: number; // Remaining leave days
  allowedDevices: string[]; // IDs of devices the employee is permitted to use

  // New Personal Details
  nationalId?: string;
  birthDate?: string;
  gender?: 'E' | 'K';
  bloodType?: string;
  address?: string;
  emergencyContactName?: string;
  emergencyContactPhone?: string;
  deviceUserId: string; // Mapping ID on ZKTeco device

  // Site & Location (Nisan-Agustos 2026'da eklendi — cok santiyeli musteriler icin)
  siteId?: number | null;
  siteName?: string;
  locationId?: number | null;
  locationName?: string;
  departmentSiteId?: number | null;   // Personel siteId yoksa departmani araciligi ile
  departmentLocationId?: number | null;
}

export interface Device {
  id: string;
  name: string;
  ipAddress: string;
  port: number;
  locationId: string;
  status: 'ONLINE' | 'OFFLINE';
  lastSync: string;
}

export interface AttendanceRecord {
  id: string;
  employeeId: string;
  deviceId: string;
  timestamp: string; // ISO String
  type: 'ENTRY' | 'EXIT';
}

export enum LeaveType {
  ANNUAL = 'Yıllık İzin',
  SICK = 'Hastalık İzni',
  UNPAID = 'Ücretsiz İzin',
  MATERNITY = 'Doğum İzni',
  EXCUSE = 'Mazeret İzni',
}

export interface LeaveRequest {
  id: string;
  employeeId: string;
  type: LeaveType;
  startDate: string;
  endDate: string;
  status: 'PENDING' | 'APPROVED' | 'REJECTED';
  reason: string;
}

export interface Holiday {
  id: string;
  name: string;
  date: string;
  type: 'PUBLIC' | 'CORPORATE';
  description?: string;
}

export interface Notification {
  id: string;
  title: string;
  message: string;
  type: 'INFO' | 'WARNING' | 'ERROR';
  timestamp: string;
  read: boolean;
  relatedEntityType?: string;
  relatedEntityId?: string;
}

export type ReportFrequency = 'DAILY' | 'WEEKLY' | 'MONTHLY';
export type ReportType = 'PUANTAJ' | 'FAZLA_MESAI' | 'GEC_KALMA' | 'YETKISIZ_ERISIM';

export interface ReportSchedule {
  id: string;
  title: string;
  reportType: ReportType;
  frequency: ReportFrequency;
  recipients: string[]; // Employee IDs (Managers)
  lastRun?: string;
  nextRun: string;
  status: 'ACTIVE' | 'PAUSED';
  format: 'PDF' | 'EXCEL';
}
